module.exports = __webpack_public_path__ + "static/media/DAI-BUSD.8e863128.svg";